var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBolt = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  preserveAspectRatio: "xMidYMid",
  viewBox: "0 0 12 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#41505F",
  fillRule: "nonzero",
  d: "M10.632 6.398H6.983a.584.584 0 0 1-.582-.583V.582c0-.567-.725-.797-1.056-.337L.11 8.68c-.274.384 0 .92.473.92H4.22c.322 0 .583.261.583.583v5.236c0 .567.725.797 1.056.337l5.248-8.437a.584.584 0 0 0-.475-.92"
})));
export { SvgBolt as ReactComponent };
export default __webpack_public_path__ + "static/media/bolt.d629a6bf.svg";